import { ActionsUnion, createAction } from '../../../redux/customActions';

export const Actions = {
    getAlcopaAccessRequested: () => createAction('user/getAlcopaAccessRequested'),
    getAlcopaAccessSucceeded: (isActif: boolean) =>
        createAction('user/getAlcopaAccessSucceeded', { isActif }),
};

export type ActionsType = ActionsUnion<typeof Actions>;
